
import Vue from "vue";

import ActivitiesMixin from "@/components/ActivitiesView/ActivitiesMixin.vue";
import WatercraftTypeActivitiesTimelineItem from "./WatercraftTypeActivitiesTimelineItem.vue";

interface IWatercraftTypeActivitiesData {
  error: string;
  message: string;
}

export default Vue.extend({
  name: "WatercraftTypeActivitiesView",
  components: { WatercraftTypeActivitiesTimelineItem },
  mixins: [ActivitiesMixin],

  data(): IWatercraftTypeActivitiesData {
    return {
      error: "",
      message: ""
    };
  },
  computed: {
    queryOverride(): any {
      return {
        name__in: `
          ADD_WATERCRAFT_TYPE_SUCCESS,
          ADD_WATERCRAFT_TYPE_FAILURE,
          UPDATE_WATERCRAFT_TYPE_SUCCESS,
          UPDATE_WATERCRAFT_TYPE_FAILURE,
          DELETE_WATERCRAFT_TYPE_SUCCESS,
          DELETE_WATERCRAFT_TYPE_FAILURE,
          BULK_DELETE_WATERCRAFT_TYPE_SUCCESS,
          BULK_DELETE_WATERCRAFT_TYPE_FAILURE,
          BULK_RESTORE_WATERCRAFT_TYPE_SUCCESS,
          BULK_RESTORE_WATERCRAFT_TYPE_FAILURE
          `.replace(/\s/g, ""),
        activityType: "WatercraftTypeActivity"
      };
    }
  }
});
